import { bounded_curve } from "./index.js";
import { cartesian_point } from "./index.js";
import { b_spline_curve_formDeserializeStep } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, SIZEOF, } from "../../step/parsing/step_deserialization_functions.js";
import { list_to_array, } from "../ap214_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class b_spline_curve extends bounded_curve {
    get type() {
        return EntityTypesAP214.B_SPLINE_CURVE;
    }
    get degree() {
        if (this.degree_ === void 0) {
            this.degree_ = this.extractNumber(1, false);
        }
        return this.degree_;
    }
    get control_points_list() {
        if (this.control_points_list_ === void 0) {
            let cursor = this.getOffsetCursor(2);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return [];
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1 = this.extractBufferElement(buffer, cursor, endCursor, cartesian_point);
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.control_points_list_ = value;
        }
        return this.control_points_list_;
    }
    get curve_form() {
        if (this.curve_form_ === void 0) {
            this.curve_form_ = this.extractLambda(3, b_spline_curve_formDeserializeStep, false);
        }
        return this.curve_form_;
    }
    get closed_curve() {
        if (this.closed_curve_ === void 0) {
            this.closed_curve_ = this.extractBoolean(4, false);
        }
        return this.closed_curve_;
    }
    get self_intersect() {
        if (this.self_intersect_ === void 0) {
            this.self_intersect_ = this.extractBoolean(5, false);
        }
        return this.self_intersect_;
    }
    get upper_index_on_control_points() {
        return SIZEOF(this?.control_points_list) - 1;
    }
    get control_points() {
        return list_to_array(this?.control_points_list, 0, this?.upper_index_on_control_points);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
b_spline_curve.query = [EntityTypesAP214.B_SPLINE_CURVE, EntityTypesAP214.UNIFORM_CURVE, EntityTypesAP214.B_SPLINE_CURVE_WITH_KNOTS, EntityTypesAP214.QUASI_UNIFORM_CURVE, EntityTypesAP214.BEZIER_CURVE];
b_spline_curve.expectedType = EntityTypesAP214.B_SPLINE_CURVE;
